module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-contact-list"
  }, [_c('div', {
    staticClass: "page"
  }, [(_vm.tagName) ? _c('div', {
    staticClass: "lxm-contact-list__tag"
  }, [_c('lxm-tag', {
    attrs: {
      "color": _vm.tagColor,
      "text": _vm.tagName
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "lxm-content-transition",
      "tag": "div",
      "mode": "out-in"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('lxm-contact-item', {
      key: item,
      attrs: {
        "id": item.id,
        "org": item.org,
        "name": item.name,
        "phone": item.phone,
        "avatar": item.avatar,
        "isFemale": item.isFemale
      }
    })
  })), _vm._v(" "), (_vm.isOne) ? _c('div', {
    staticClass: "lxm-contact-list__one"
  }, [_vm._v("登录灵析电脑版，可以为联系人分类哦～")]) : _vm._e(), _vm._v(" "), (_vm.hasMore) ? _c('lxm-more', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.moreClicked
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eaac1e9e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eaac1e9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Contact/List.vue
// module id = 894
// module chunks = 0